import './CalendarHeaderNotification.scss';
import { useTranslation } from 'react-i18next';


const CalendarHeaderNotification = ({successMsgDetails}) => {
    const { t } = useTranslation();

    return (
        <div className="calendar-header-notification calendar-header-notification--success">
            <i className="icon-Confirmation-circle-green" />
            <p>{`${t('myBlockMonth.stripCalendarHeader.syncCalMbmPageAddAccount',{email:successMsgDetails.emailId})}(${successMsgDetails.nickName}) ${t('myBlockMonth.stripCalendarHeader.syncCalMbmPageAddAccount1')}`}&nbsp;
                <span className="notification__new-line">
                    {t('myBlockMonth.stripCalendarHeader.syncCalMbmPageAddAccount2')} <a className='calendar-header__setings-link-content' href='/settings'>{t('myBlockMonth.stripCalendarHeader.syncCalMbmPageAddAccount3')}</a>{t('myBlockMonth.stripCalendarHeader.syncCalMbmPageAddAccount4')}
                </span>
            </p>
        </div>
    )
}

export default CalendarHeaderNotification;